import {
  IconAlarm,
  IconChartArrowsVertical,
  IconCheckbox,
  IconCheckupList,
  IconFileBarcode,
  IconListTree,
  IconMap,
  IconMessageCircleStar,
  IconUserBolt,
  TablerIconsProps
} from "@tabler/icons-react";
import {ReactElement, useMemo} from "react";
import {useTranslation} from "react-i18next";
import {useGetPendingDispatchRequests} from "./useGetPendingDispatchRequests";

export type NavLinkItem = {
  icon: (props: TablerIconsProps) => ReactElement
  label: string
  path: string
  notifications?: number
  permissions?: string[]
}

/** DispatchGo's primary destinations, shared by the side and top navigation. */
export const useNavLinks = (): NavLinkItem[] => {
  const {t} = useTranslation(["translation"]);
  const {dispatchRequests} = useGetPendingDispatchRequests();
  const pendingDispatchRequestCount = dispatchRequests.length;

  return useMemo(() => [
    {
      icon: IconUserBolt,
      label: t<string>("app.navbar.item.driveractivity", "Driver Activity"),
      path: "/driver-activity"
    },
    {
      icon: IconCheckbox,
      label: t<string>("app.navbar.item.dispatch", "Dispatch"),
      path: "/dispatch"
    },
    {
      icon: IconMessageCircleStar,
      label: t<string>("app.navbar.item.dispatchrequests", "Dispatch Requests"),
      path: "/requests",
      notifications: pendingDispatchRequestCount > 0 ? pendingDispatchRequestCount : undefined
    },
    {
      icon: IconChartArrowsVertical,
      label: t<string>("app.navbar.item.containerstatus", "Container Status"),
      path: "/container-status"
    },
    {
      icon: IconFileBarcode,
      label: t<string>("app.navbar.item.ticket", "Tickets"),
      path: "/tickets"
    },
    {
      icon: IconAlarm,
      label: t<string>("app.navbar.item.shift", "Shifts"),
      path: "/shifts"
    },
    {
      icon: IconCheckupList,
      label: t<string>("app.navbar.item.dvir", "DVIRs"),
      path: "/dvirs",
      permissions: ["dvir_view"],
    },
    {
      icon: IconMap,
      label: t<string>("app.navbar.item.map", "Map"),
      path: "/map"
    },
    {
      icon: IconListTree,
      label: t<string>("app.navbar.item.directory", "Directory"),
      path: "/directory",
    }
  ], [pendingDispatchRequestCount, t]);
};
